export const messages = {
  en: {
    createPartner: "Sent",
    createCompany: "The company was created",
    deleteCompany: "Deleted",
    deleteUser: "The user has been deleted",
    deleteTicket: "Ticket has been deleted",
    connectToPartner: "Sent",
    disconnectFromPartner: "Deactivated",
    responseToConnectionRequest: "Sent",
    removePartner: "The partner has been deleted",
    editSupervisorInfo: "The supervisor has been changed",
    updateMakrup: "Markup has been changed",
    removeSupervisor: "The supervisor has been deleted",
    createSupervisor: "The supervisor has been created",
    editPartnerInfo: "The supervisor has been changed",
    updateBalance: "The balance has been changed",
    changeMainStatus: "The status has been changed",
    changePartnersStatus: "The status has been changed",
    duplicatePartnersSuccess: "The Partner has been duplicated",
    changeConsolidatorsStatus: "The status has been changed",
    changeAgenciesStatusActive: "The company has moved into active",
    changeAgenciesStatusBlocked: "The company has moved into blocked",
    updateAdminsChannel: "The channel status has been changed",
    updateSupervisorsChannel: "The channel status has been changed",
    createChannel: "The channel has been created",
    removeChannel: "The channel has been deleted",
    cardCreated: "Card was added",
    cardRemoved: "Card was removed",
    createCredentialsDataActive: "The credentials are correct. Enable the channel to get started. ",
    createCredentialsDataInactive: "Invalid credentials. Enter current cretentials.",
    editCredentialsDataActive: "The credentials are correct.",
    editCredentialsDataInactive: "Invalid credentials. Enter current cretentials.",
    updateCompaniesChannel: "The channel status has been changed",
    updatePartnersChannel: "The channel status has been changed",
    updateChannelNegoCode: "The channel NEGO code has been changed",
    updateChannelResidentFaresCode: "The channel Resident fares code has been changed",
    exportNoTickets: "No tickets for selected dates",
    saveAccountInfo: "The information has been successfully updated",
    acceptPhoneChanging: "The phone number has been updated",
    bookAncillaries: "Ancillaries are booked",
    asyncBookAncillaries: "Additional services are in the issue process. Check the status next to the passenger's name.",
    processAncillaries: "We're processing your request for additional services. Once completed, they will appear in your booking and the Sales section.",
    issueBooking: "The tickets have been issued",
    issueFakeBooking: "The ticket issue is in progress. Please check notifications for tickets or errors.",
    voidBooking: "The tickets have been voided",
    manualVoidBooking: "Ticket void is in progress. Please check the status in Sales later.",
    cancelBooking: "Booking is cancelled",
    changeCompanyVisibility: "Visibility has been changed",
    serverError: "There are problems on the server",
    booked_1: "Booking",
    booked_2: "is created. Time limit till",
    booked_expires_at: "Dynamic pricing. Open the booking to check the actual time limit.",
    price_changed_1: "Price changed from",
    price_changed_2: "to",
    openBookingLink: "Open Booking",
    bookingUpdated: "Booking updated",
    apiKeyGenerated: "API key generated",
    apiKeyUpdated: "API key updated",
    reportSent: "The report will be sent to your email soon",
    refundBooking: "Refund was successfully completed and added to the \"Sales\" section",
    issue_1: "Booking",
    issue_2: "successfully issued",
    updateTransactionFee: 'Markups have been changed',
    exchagedTitle: "Order successfully changed",
    commentUpdated: "Your comment was successfully saved",
    refreshFailed: "Refresh failed. Please try again.",
    searchFailed: "Search failed. Please try again.",
    credentialCreated: "The credential has been created",
    credentialUpdated: "The credential has been updated",
    credentialDeleted: "The credential has been deleted",
    credentialDeletedUnlinked: "The credential has been deleted and unlinked from {n} agency | The credential has been deleted and unlinked from {n} agencies",
    credentialLinked: "The credential has been linked to the channel",
    credentialLinkedInactive: "The linked credential is invalid, the channel will not work until it is fixed",
    credentialCarriersUpdated: "The channel carriers have been updated",
    credentialUnlinked: "The credential has been unlinked from the channel"
  },
  ua: {
    createPartner: "Відправлено",
    createCompany: "Компанію створено",
    deleteCompany: "Видалено",
    deleteUser: "Користувача видалено",
    deleteTicket: "Квиток видалено",
    connectToPartner: "Відправлено",
    disconnectFromPartner: "Деактивовано",
    responseToConnectionRequest: "Відправлено",
    removePartner: "Партнера видалено",
    editSupervisorInfo: "Супервайзера змінено",
    updateMakrup: "Маркапи змінено",
    removeSupervisor: "Супервізора видалено",
    createSupervisor: "Супервізора створено",
    editPartnerInfo: "Супервайзера змінено",
    updateBalance: "Баланс змінено",
    changeMainStatus: "Статус змінено",
    changePartnersStatus: "Статус змінено",
    duplicatePartnersSuccess: "Партнера скопійовано",
    changeConsolidatorsStatus: "Статус змінено",
    changeAgenciesStatusActive: "Компанію перенесено до активних",
    changeAgenciesStatusBlocked: "Компанію перенесено до заблокованих",
    updateAdminsChannel: "Статус каналу змінено",
    updateSupervisorsChannel: "Статус каналу змінено",
    createChannel: "Канал створено",
    removeChannel: "Канал видалено",
    cardCreated: "Картку створено",
    cardRemoved: "Картку видалено",
    createCredentialsDataActive: "Доступи підійшли. Увімкніть канал, щоб почати. ",
    createCredentialsDataInactive: "Неправильні доступи. Введіть дійсні дані.",
    editCredentialsDataActive: "Доступи підійшли.",
    editCredentialsDataInactive: "Неправильні доступи. Введіть дійсні дані.",
    updateCompaniesChannel: "Статус каналу змінено",
    updatePartnersChannel: "Статус каналу змінено",
    updateChannelNegoCode: "NEGO код каналу змінено",
    updateChannelResidentFaresCode: "Resident fares код каналу змінено",
    exportNoTickets: "Немає квитків на обрані дати",
    saveAccountInfo: "Інформацію успішно оновлено",
    acceptPhoneChanging: "Номер телефону оновлено",
    bookAncillaries: "Додаткові послуги заброньовано",
    asyncBookAncillaries: "Послуги в процесі виписки. Перевіряйте статус біля імені пасажира.\n",
    processAncillaries: "Працюємо над оформленням додаткових послуг. Після завершення вони з'являться у бронюванні та в розділі «Продажі».",
    issueBooking: "Квитки успішно виписано",
    issueFakeBooking: "Триває оформлення квитків. Перевірте, будь ласка, сповіщення про оформлення квитків або помилки.",
    voidBooking: "Квитки войдовано",
    manualVoidBooking: "Войд квитків у процесі. Будь ласка, перевірте статус у Sales пізніше.",
    cancelBooking: "Бронювання анульовано",
    changeCompanyVisibility: "Видимість",
    serverError: "Проблеми на сервері",
    booked_1: "Бронювання",
    booked_2: "створено. Тайм ліміт до",
    booked_expires_at: "Динамічне ціноутворення. Відкрийте бронь, щоб перевірити актуальний тайм ліміт.",
    price_changed_1: "Ціна змінилася з",
    price_changed_2: "на",
    openBookingLink: "Відкрити Бронювання",
    bookingUpdated: "Бронювання оновлено",
    apiKeyGenerated: "API ключ створено",
    apiKeyUpdated: "API ключ оновлено",
    reportSent: "Звіт буде надіслано на вашу електронну адресу найближчим часом",
    issue_1: "Бронювання",
    issue_2: "успішно виписане",
    updateTransactionFee: 'Маркапи оновлено',
    exchagedTitle: "Бронювання успішно змінено",
    commentUpdated: "Ваш коментар успішно збережено",
    refreshFailed: "Не вдалося оновити. Спробуйте ще раз.",
    searchFailed: "Пошук не вдався. Спробуйте ще раз.",
    credentialCreated: "Доступи створено",
    credentialUpdated: "Доступи оновлено",
    credentialDeleted: "Доступи видалено",
    credentialDeletedUnlinked: "Доступи видалено та відв'язано від {n} агентства | Доступи видалено та відв'язано від {n} агентств | Доступи видалено та відв'язано від {n} агентств",
    credentialLinked: "Доступи прив'язано до каналу",
    credentialLinkedInactive: "Прив'язані доступи недійсні, канал не працюватиме, доки їх не виправлять",
    credentialCarriersUpdated: "Перевізників каналу оновлено",
    credentialUnlinked: "Доступи відв'язано від каналу"
  },
  pl: {
    createPartner: "Wysłany",
    createCompany: "Firma została utworzona",
    deleteCompany: "Usunięto",
    deleteUser: "Użytkownik został usunięty",
    deleteTicket: "Bilet został usunięty",
    connectToPartner: "Wysłano",
    disconnectFromPartner: "Deaktywowany",
    responseToConnectionRequest: "Wysłany",
    removePartner: "Partner został usunięty",
    editSupervisorInfo: "Przełożony został zmieniony",
    updateMakrup: "Zmieniono znaczniki",
    removeSupervisor: "Przełożony został usunięty",
    createSupervisor: "Przełożony został utworzony",
    editPartnerInfo: "Przełożony został zmieniony",
    updateBalance: "Saldo zostało zmienione",
    changeMainStatus: "Status został zmieniony",
    changePartnersStatus: "Status został zmieniony",
    duplicatePartnersSuccess: "Partner został zduplikowany",
    changeConsolidatorsStatus: "Status został zmieniony",
    changeAgenciesStatusActive: "Firma została aktywna",
    changeAgenciesStatusBlocked: "Firma została zablokowana",
    updateAdminsChannel: "Status kanału został zmieniony",
    updateSupervisorsChannel: "Status kanału został zmieniony",
    createChannel: "Kanał został utworzony",
    removeChannel: "Kanał został usunięty",
    cardCreated: "Karta została dodana",
    cardRemoved: "Karta została usunięta",
    createCredentialsDataActive: "Dane uwierzytelniające są poprawne. Włącz kanał, aby rozpocząć. ",
    createCredentialsDataInactive: "Nieprawidłowe dane. Wprowadź aktualne dane uwierzytelniające.",
    editCredentialsDataActive: "Dane uwierzytelniające są poprawne.",
    editCredentialsDataInactive: "Nieprawidłowe dane. Wprowadź aktualne dane uwierzytelniające.",
    updateCompaniesChannel: "Status kanału został zmieniony",
    updatePartnersChannel: "Status kanału został zmieniony",
    updateChannelNegoCode: "NEGO code kanału został zmieniony",
    updateChannelResidentFaresCode: "Resident fares code kanału został zmieniony",
    exportNoTickets: "Brak biletów na wybrane daty",
    saveAccountInfo: "Informacje zostały pomyślnie zaktualizowane",
    acceptPhoneChanging: "Numer telefonu został zaktualizowany",
    bookAncillaries: "Usługi dodatkowe są zarezerwowane",
    asyncBookAncillaries: "Dodatkowe usługi są w trakcie wydawania. Sprawdź status obok nazwiska pasażera.",
    processAncillaries: "Pracujemy nad dodaniem wybranych usług dodatkowych. Po zakończeniu pojawią się w rezerwacji oraz w sekcji Sprzedaż.",
    issueBooking: "Bilety zostały wystawione",
    issueFakeBooking: "Wystawianie biletów jest w toku. Sprawdź powiadomienia o biletach lub błędach",
    voidBooking: "Bilety zostały unieważnione",
    manualVoidBooking: "Void biletów jest w toku. Prosimy o sprawdzenie statusu w Sales później.",
    cancelBooking: "Rezerwacja została anulowana",
    changeCompanyVisibility: "Widoczność została zmieniona",
    serverError: "Wystąpiły problemy na serwerze",
    booked_1: "Rezerwacja",
    booked_2: "została utworzona. Limit czasu do",
    booked_expires_at: "Dynamiczne ustalanie cen. Otwórz rezerwację, aby sprawdzić aktualny limit czasu.",
    price_changed_1: "Cena zmieniła się z",
    price_changed_2: "na",
    openBookingLink: "Otwórz rezerwację",
    bookingUpdated: "Rezwrwacja zaktualizowana",
    apiKeyGenerated: "Wygenerowano klucz API",
    apiKeyUpdated: "Klucz API zaktualizowany",
    reportSent: "Raport zostanie wkrótce wysłany na twój adres e-mail",
    refundBooking: "Повернення успішно проведено та додано до розділу «Продажі»",
    issue_1: "Rezerwacja",
    issue_2: "została pomyślnie wystawiona",
    exchagedTitle: "Order successfully changed",
    commentUpdated: "Twój komentarz został pomyślnie zapisany",
    refreshFailed: "Odświeżanie nie powiodło się. Spróbuj ponownie.",
    searchFailed: "Wyszukiwanie nie powiodło się. Spróbuj ponownie.",
    credentialCreated: "Dane dostępowe zostały utworzone",
    credentialUpdated: "Dane dostępowe zostały zaktualizowane",
    credentialDeleted: "Dane dostępowe zostały usunięte",
    credentialDeletedUnlinked: "Dane dostępowe zostały usunięte i odłączone od {n} agencji | Dane dostępowe zostały usunięte i odłączone od {n} agencji | Dane dostępowe zostały usunięte i odłączone od {n} agencji",
    credentialLinked: "Dane dostępowe zostały przypisane do kanału",
    credentialLinkedInactive: "Przypisane dane dostępowe są nieprawidłowe, kanał nie będzie działał, dopóki nie zostaną poprawione",
    credentialCarriersUpdated: "Przewoźnicy kanału zostali zaktualizowani",
    credentialUnlinked: "Dane dostępowe zostały odłączone od kanału"
  }
}
